import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const ResourcePacketContext = createContext(null);
const STORAGE_KEY = 'inasw_resource_packet';

export const ResourcePacketProvider = ({ children }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) { /* noop */ }
  }, []);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch (e) { /* noop */ }
  }, [items]);

  const addItem = useCallback((resource) => {
    setItems((prev) => (prev.some((r) => r.resource_id === resource.resource_id) ? prev : [...prev, {
      resource_id: resource.resource_id, name: resource.name, category: resource.category,
      description: resource.description, phone: resource.phone, website: resource.website,
      address: resource.address, city: resource.city, state: resource.state, zip_code: resource.zip_code,
      hours: resource.hours,
    }]));
  }, []);

  const removeItem = useCallback((id) => setItems((prev) => prev.filter((r) => r.resource_id !== id)), []);
  const clear = useCallback(() => setItems([]), []);
  const inPacket = useCallback((id) => items.some((r) => r.resource_id === id), [items]);

  return (
    <ResourcePacketContext.Provider value={{ items, addItem, removeItem, clear, inPacket, count: items.length }}>
      {children}
    </ResourcePacketContext.Provider>
  );
};

export const useResourcePacket = () => {
  const ctx = useContext(ResourcePacketContext);
  if (!ctx) throw new Error('useResourcePacket must be used within ResourcePacketProvider');
  return ctx;
};
